var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"atom-collapse-indicator"},[_c('AngleRightSVG',{staticClass:"atom-collapse-indicator__angle",class:{ 'atom-collapse-indicator__angle--rotate-down': _vm.open }})],1)}
var staticRenderFns = []

export { render, staticRenderFns }